import { render, staticRenderFns } from "./MainViewCollectionMobile.vue?vue&type=template&id=02eb98e6&scoped=true&"
import script from "./MainViewCollectionMobile.vue?vue&type=script&lang=js&"
export * from "./MainViewCollectionMobile.vue?vue&type=script&lang=js&"
import style0 from "./MainViewCollectionMobile.vue?vue&type=style&index=0&id=02eb98e6&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02eb98e6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VImg})
